module.exports = __webpack_public_path__ + "img/logo.eee9bcd4.png";